package com.essntl.uikit.components.checkbox

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsLargeIcon
import com.essntl.uikit.theme.esColorScheme

@Composable
fun EsCheckBox(
    checked: Boolean,
    onCheckedChange: (Boolean) -> Unit,
    colors: EsCheckBoxColors,
    enabled: Boolean = true,
    modifier: Modifier = Modifier,
) {
    EsTriCheckBox(
        state = if (checked) EsCheckBoxState.Checked else EsCheckBoxState.Unchecked,
        onClick = { onCheckedChange(!checked) },
        colors = colors,
        enabled = enabled,
        modifier = modifier,
    )
}

@Composable
fun EsTriCheckBox(
    state: EsCheckBoxState,
    onClick: () -> Unit,
    colors: EsCheckBoxColors,
    enabled: Boolean = true,
    modifier: Modifier = Modifier,
) {
    Box(
        contentAlignment = Alignment.Center,
        modifier = modifier
            .size(24.dp)
            .background(
                color = when {
                    !enabled -> colors.disabledCheckedBoxColor
                    state != EsCheckBoxState.Unchecked -> colors.backgroundCheckedBoxColor
                    else -> colors.backgroundUncheckedBoxColor
                },
                shape = RoundedCornerShape(5.dp),
            )
            .border(
                width = if (state != EsCheckBoxState.Unchecked) 2.dp else 0.dp,
                color = when {
                    !enabled -> colors.disabledCheckedBoxColor
                    state != EsCheckBoxState.Unchecked -> colors.borderCheckedBoxColor
                    else -> colors.backgroundUncheckedBoxColor
                },
                shape = RoundedCornerShape(5.dp),
            )
            .clip(RoundedCornerShape(5.dp))
            .clickable(
                enabled = enabled
            ) {
                onClick()
            },
    ) {
        if (state != EsCheckBoxState.Unchecked) {
            EsLargeIcon(
                res = if (state == EsCheckBoxState.Checked) EsIcons.Check else EsIcons.Minus,
                tint = if (enabled) colors.checkMarkColor else colors.disabledCheckMarkColor,
                modifier = Modifier.align(Alignment.Center),
            )
        }
    }
}

enum class EsCheckBoxState {
    Checked,
    Unchecked,
    Indeterminate,
}

class EsCheckBoxColors(
    val backgroundCheckedBoxColor: Color,
    val backgroundUncheckedBoxColor: Color,
    val borderCheckedBoxColor: Color,
    val disabledCheckedBoxColor: Color,
    val checkMarkColor: Color,
    val disabledCheckMarkColor: Color,
)